export enum WidgetVersionType {
  Sql = '1',
  Druid = '2',
  Oracle = '3',
}
